(function ($) {

    /* javascript code goes here.  Will run after page is loaded in the DOM */


    $('document').ready(function () {


        //update breakpoints for javascript
        themeJs.breakpoint.refreshValue();

        // Lazy load video
        //new LazyVideoLoader();


        // change title attribute of audio files
        setTimeout( function() {
            $('.mejs-playpause-button button').attr('title', 'Listen Here');


        }, 1000);
        setTimeout( function() {
            $('.mejs-playpause-button button').attr('title', 'Listen Here');


        }, 2000);
    
        /* Track form converstions with Contact Form 7 */
        /*
                document.addEventListener( 'wpcf7mailsent', function( event ) {
                    ga( 'send', 'event', 'Contact Form', 'submit' );
                }, false );

        */

        /* Menu
        ------------------------------------------------------------------ */
        $('.not-loaded-height').removeClass('not-loaded-height');
        /**
         * This section looks for img tags in elements not loaded with the class responsive-background-image
         * It will change the data-src and data-srcset to src and src-set so the browser can choose which image to load
         * Once loaded the script will copy the src to the background of the slide and then remove the img tag
         * Class not-loaded is used to keep the slide's opacity at 0 until it is removed after image is loaded.
         *
         */

        /**
         * Function to call to load a responsive background image to parent element
         * @param el
         */
        const loadBgImg = function (el) {
            let $this = $(el);

            //Read in the data-srcset attributes of this img tag

            let dataSrcSet = $this.data('srcset');

            if (dataSrcSet) {
                $this.attr('srcset', dataSrcSet);
            }
            let $parent = $this.parent();
            $this.css('opacity', 0).removeClass('responsive-background-image');
            // imagesLoaded will run the function once the image is fully loaded to the browser
            $parent.imagesLoaded(function () {
                //once image is loaded, see which image size the browser chose based on the srcset
                let backgroundSrc = (typeof $this[0].currentSrc !== 'undefined' && $this[0].currentSrc !== '') ? $this[0].currentSrc : $this.data('fallback');
                //console.log( 'currentSrc: ' + $this[0].currentSrc );
                let orig = $parent.css('background-image'); //get any existing image (linear gradient)
                $parent.css('background-image', orig + ',url("' + backgroundSrc + '")');
                $this.remove(); //remove img tag from markup
                $parent.addClass('responsive-background-image-loaded');
            });


        };

        /*

                // Load Hero background images
                let $heroImages = $('.site-hero').find('.responsive-background-image');
                //console.log($heroImages);
                if ($heroImages.length > 0) {
                    $heroImages.each(function () {
                        // console.log(this);
                        loadBgImg(this);
                        $parent = $(this).closest('.hero-image');  // find the container we are in and remove not-loaded once image is fully loaded.
                        $parent.imagesLoaded({background: true}, function () {
                            $parent.removeClass('not-loaded');
                        })
                    })
                }
        */


        /**BEGIN: Section lazy loading
         *
         * Check if sections are in view.  If so, load images, and remove .not-loaded
         */

        let $sectionsToLoad = $('section.lazy, .site-hero, article.lazy');

        /**
         * loadInView goes through each section.not-loaded and determines of it is in view.  If so, loads any responsive-background-images
         */
        const loadInView = function () {
            $sectionsToLoad.filter('.not-loaded').each(function (i, section) {
                let $section = $(section);
                if (themeJs.Utils.isElementInView(section)) {
                    let $bgImgs = $section.find('.responsive-background-image');
                    if ($bgImgs.length > 0) {
                        $bgImgs.each(function () {
                            loadBgImg(this);
                        })
                    }
                    $section.imagesLoaded({background: true})  //once image is loaded into DOM, remove class .not-loaded.  Even if error.
                        .always(function () {

                            $section.removeClass('not-loaded');
                        });

                }
            });

        };

        //run Load in view on page load for all sections already in viewport
        loadInView();
        setTimeout(loadInView, 1000);
        themeJs.loadInView = loadInView;

        const onScrollLoadInView = new Debouncer(function () {
            loadInView();
        });
        $(window).on('scroll', onScrollLoadInView.handleEvent.bind(onScrollLoadInView));  //check if new section.not-loaded has come into view on scroll event.

        /**END: Section lazy loading
         *
         * Check if sections are in view.  If so, load images, and remove .not-loaded
         */


        /* Sections *
      --------------------------------------------------------------------------------------
         */

        const galleries = '.gwGallery';
        const $galleries = $(galleries);
        const gwThumbnail = '.gwGallery__thumbnail';
        const gwLarge = '.gwGallery__large';
        const gwImage = '.gwGallery__image';

        if ($galleries.length > 0) {

            $(gwThumbnail).on('click', function (e) {
                const $this = $(this);
                const index = $this.attr('data-index');
                const $gallery = $this.closest(galleries);
                const galleryData = $gallery.attr('data-gallery');
                const $gwLarge = $gallery.find(gwLarge);
                const indexLarge = $gwLarge.attr('data-index');


                //move thumbnail to Large


                $gwLarge.find(gwImage).css('background-image', 'url(' + themeJs[galleryData][index]['full'] + ')');
                $gwLarge.attr('data-index', index);

                //move Large to thumbnail

                $this.find(gwImage).css('background-image', 'url(' + themeJs[galleryData][indexLarge]['medium'] + ')');
                $this.attr('data-index', indexLarge);

                // move classes since some will be padded or need background-size = contain
                const gwLargeClasses = $gwLarge.find(gwImage).attr('class');
                const gwThumbnailClasses = $this.find(gwImage).attr('class');
                $gwLarge.find(gwImage).attr('class', gwThumbnailClasses);
                $this.find(gwImage).attr('class', gwLargeClasses);

            });
        }


        /* Modal
        ------------------------------------------------------------------------------------         */

        $('.modal').on('shown.bs.modal', function () {
            $(this).trigger('focus')
        });

        // load images
        $('.modal').on('show.bs.modal', function () {
            let $bgImgs = $(this).find('.responsive-background-image');
            if ($bgImgs.length > 0) {
                $bgImgs.each(function () {
                    loadBgImg(this);
                });

            }


        });

        $('.collapse').on('shown.bs.collapse', function () {

            $(this).closest('.modal').modal('handleUpdate');
        });


        /* Timeline/Community Component
        --------------------------------------------------------------------------------- */


        /* Swiper sliders - Timeline/Community Component
        --------------------------------------------------------------*/


        const $timelineTop = $('.timeline__top');
        const verticalBreakpoints = function () {
            return (['lg', 'xl'].indexOf(themeJs.breakpoint.value) > -1);
        } //true when thumbs are vertical


        $timelineTop.each(function () {

            const $this = $(this);
            const thumbs = $this.attr('data-thumbs');
            const $thumbs = $(thumbs);


            const timelineTop = new Swiper(this, {
                // Disable preloading of all images
                preloadImages: false,
                // Enable lazy loading
                lazy: true,
                spaceBetween: 10,

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }

            });

            $thumbs.find('[data-slide]').on('click', function () {
                const slide = $(this).attr('data-slide');
                timelineTop.slideTo(slide)
            });

            timelineTop.on('slideChange', function () {
                const slide = this.realIndex;
                const tslide = $thumbs.find('[data-slide="' + slide + '"]');
                $thumbs.find('[data-slide]').removeClass('active');
                tslide.addClass('active');


                if (verticalBreakpoints()) {
                    themeJs.scrollVertInContainer($('.timeline__thumbnail-wrapper'), tslide);
                } else {
                    themeJs.scrollLeftToElement($('.timeline__thumbnail-wrapper'), tslide);
                }
            });


            // See what media breakpoint we are at.  If on lg or xl, then match heights.
            const thumbsResize = function () {
                if (verticalBreakpoints()) {
                    $('.timeline__thumbnail-wrapper').height($('.timeline__top').height())
                } else {
                    $('.timeline__thumbnail-wrapper').height('auto');
                }
            }
            thumbsResize();

            const debouncedthumbsResize = new themeJs.Debouncer(thumbsResize);
            window.addEventListener('resize', debouncedthumbsResize.handleEvent.bind(debouncedthumbsResize));

        });


    })

})(jQuery);
